import React from 'react';
import { Link } from 'react-router-dom';
import { formatClientPublishDate } from '../../constants/dateTimeFormat';
import './index.css';

const BlockArchiveItem = ({
  title,
  redirect,
  img,
  publishDate,
  unpublishDate,
  bg,
  endingLabel,
}) => {
  const grey = 'background-grey';
  const white = 'background-white';
  const background = bg === 'grey' ? grey : white;
  const from = formatClientPublishDate(publishDate);
  const to = formatClientPublishDate(unpublishDate);

  return (
    <Link to={redirect} className="archive-item__link-container">
      <div className={`${background} archive-item`}>
        <div className="archive-item__img-container">
          <img src={img} alt={title} />
        </div>
        <div className="archive-item__content">
          <div className="archive-item__info">
            <div className="archive-item__title">{title}</div>
            <div className="archive-item__dates">
              {from}
              {from && to && '-'}
              {to}
            </div>
          </div>
          <div className="archive-item__alert">{endingLabel}</div>
        </div>
      </div>
    </Link>
  );
};

export default BlockArchiveItem;
